<div class="mx-2 mb-2">
    <div class="d-flex justify-content-between align-items-center">
        <h1 class="fw-bold col-lg-6 mb-0">{{header_title | translate}}</h1>
        <button (click)="location.back()" class="btn btn-secondary">
            <mat-icon>keyboard_backspace</mat-icon>
        </button>
    </div>
</div>